import GetRequest from '@/api/main/requests/GetRequest';
import JSONResponseHandler from '@/api/main/handlers/JSONResponseHandler';
import { normalizeLanguageCode } from '@/lib/language';
import { resolveCurrentAgencySlug } from '@/lib/agencySlug';
const GET_LOCATION_SUGGESTIONS_URL = '/public/location-suggestions';
export class GetLocationSuggestionsRequest extends GetRequest {
    constructor(params) {
        super();
        this.responseHandler = new JSONResponseHandler();
        this.params = params;
        if (params.signal) {
            this.requestInitPart = {
                ...this.requestInitPart,
                signal: params.signal,
            };
        }
    }
    get url() {
        const queryParams = new URLSearchParams();
        const query = this.params.q?.trim() ?? '';
        queryParams.set('q', query);
        const normalizedCountry = this.params.country?.trim().toUpperCase();
        if (normalizedCountry) {
            queryParams.set('country', normalizedCountry);
        }
        const normalizedLanguage = normalizeLanguageCode(this.params.language);
        if (normalizedLanguage) {
            queryParams.set('language', normalizedLanguage);
        }
        const normalizedLimit = Number.isFinite(this.params.limit)
            ? Math.max(1, Math.min(8, Math.floor(this.params.limit)))
            : 5;
        queryParams.set('limit', String(normalizedLimit));
        const agencySlug = this.params.agencySlug ?? resolveCurrentAgencySlug();
        if (agencySlug) {
            queryParams.set('agencySlug', agencySlug);
        }
        return `${GET_LOCATION_SUGGESTIONS_URL}?${queryParams.toString()}`;
    }
}
